import Helper from './Helper';

class Sharing {
  constructor(config = {}) {
    const {} = config;
    this.switchButtons = Array.prototype.slice.call(document.querySelectorAll('.wp-sharing__link--toggle'));

    if (this.switchButtons && this.switchButtons.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.switchButtons.forEach( button => {
      button.addEventListener('click', (e) => {
        if (button.classList.contains('toggle-active')) {
          button.classList.remove('toggle-active')
        } else {
          button.classList.add('toggle-active')
        }
      });
    });
  }

}

export default Sharing;
